var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefault9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1456_169119)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ext4_1",
    x: 0.181641,
    width: 40,
    height: 40,
    rx: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "ext2_1",
    d: "M26.8875 29.0127L-16.4854 23.3817L19.927 -14.1668L26.8875 29.0127Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ext2_2_stroke",
    d: "M28.7429 12.7682C29.2715 12.3065 30.099 12.5187 30.34 13.1779L42.5196 46.4863C42.796 47.2423 42.1116 47.9984 41.3319 47.7984L2.44297 37.8224C1.66332 37.6224 1.42738 36.6302 2.03356 36.1006L28.7429 12.7682Z",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1456_169119"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.181641,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault9);
export default __webpack_public_path__ + "static/media/Default9.80e0ef03.svg";
export { ForwardRef as ReactComponent };